import { render, staticRenderFns } from "./ActPraktekMandiri.vue?vue&type=template&id=709b0a12"
import script from "./ActPraktekMandiri.vue?vue&type=script&lang=js"
export * from "./ActPraktekMandiri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports